import { Button as MaterinalButton } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

const Button = ({ isLoading = false,children,...props }) => {
    return (
        <MaterinalButton {...props} disabled={props.disabled || isLoading}>{isLoading && !props.disabled ? <CircularProgress sx={{ color: '#7338A0' }} size={25} /> : children}</MaterinalButton>
    )
}

export default Button